import hooks from './shipment-invoices.hooks';

export default (app) => {
  const service = app.service('api/shipment-invoices');
  // TODO: Remove this with feathers-dataloader update
  service.options = {
    id: 'id'
  };
  service.hooks(hooks);
};
